var React = require('react');

function Customs (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Customs"),React.createElement("g",{"id":"g1457","key":2},[React.createElement("path",{"id":"path7034","className":"cls-1","d":"M64,1,46,19H82Z","key":0}),React.createElement("rect",{"id":"rect7036","className":"cls-1","x":"37","y":"37","width":"54.01","height":"54.01","key":1}),React.createElement("path",{"id":"path7034-4","className":"cls-1","d":"M64,127l18-18H46Z","key":2}),React.createElement("path",{"id":"path7034-8","className":"cls-1","d":"M127,64,109,46V82Z","key":3}),React.createElement("path",{"id":"path7034-7","className":"cls-1","d":"M1,64,19,82V46Z","key":4})])]);
}

Customs.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Customs;

Customs.default = Customs;
